<template>
    <div>
      <div class="fu">
        <h1 class="title">如何查看电池BT码</h1>
        <p class="test">
            小编在抓紧制作内容中，敬请期待哦  
        </p>

       </div>
    </div>
  </template>
  
  <script>
    export default {
            name:"WachBt"
    }
  </script>
  
  <style scoped>
  @media(max-width:768px) {
    .test{
    font-size: 5vw;
    border-left: 5px solid #42b983;
    background-color: #f3f5f7;
    padding-left:1vw;
    font-family: Helvetica Neue, SimSun, 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  }
    .title{
    font-size: 6vw;
    color: #2c3e50;
  }
    .antenae{
    width: 90vw;
    height: 45vh;
    }
    .fu{
      width:100%;
      margin-left: 0px;
    }
  }
  
  @media (min-width: 768px){
    .test{
    font-size: 20px;
    border-left: 5px solid #42b983;
    background-color: #f3f5f7;
    padding-left:1vw;
    font-family: Helvetica Neue, SimSun, 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  }
  .title{
    font-size: 30px;
    color: #2c3e50;
  }
  .fu{
  margin-left: 13vw;
  margin-right: 7vw;
  }
  .antenae{
    width: 50vw;
    height: 60vh;
  }
  }
  </style>